import { lazyLoad } from 'site-modules/shared/components/lazy-load/lazy-load';

export const YoutubeVideoModalAsync = lazyLoad({
  loader: () => import(/* webpackChunkName: "youtube-video-modal" */ './youtube-video-modal'),
  componentName: 'YoutubeVideoModal',
});
